import { Component, ComponentRef, Input, OnInit, ViewChild } from "@angular/core";
import { IntegrationEnum } from "app/enums";
import { ThirdPartySectionDirective } from "./third-party-section.directive";
import { MagnumComponent } from "@Components/third-party-section/magnum/magnum.component";
import { MrasInterviewComponent } from "@Components/third-party-section/mras/mras-interview.component";
import { AppService } from "app/app.service";
import { SharedModule } from "@Shared/shared.module";

@Component({
    selector: 'third-party-section',
    template: `
        <div>
            <ng-template thirdParty></ng-template>
        </div>
    `,
    imports: [SharedModule, ThirdPartySectionDirective, MagnumComponent, MrasInterviewComponent]
})
export class ThirdPartySection implements OnInit {
    componentRef: ComponentRef<ThirdPartySectionComponent>;
    _embeddedData: EmbeddedIntegrationData;
    isInitialized = false;

    constructor(
        private appService: AppService
    ) {

    }

    get embeddedData() {
        return this._embeddedData;
    }

    @Input() set embeddedData(value) {
        this._embeddedData = value;

        if (this.embeddedData.integrationId === IntegrationEnum.Mras && this.isInitialized) {
            this.loadThirdPartySectionComponent();
            return;
        }

        if (this.componentRef) {
            this.componentRef.instance.embeddedData = this.embeddedData;
        }
    }

    @Input() isCaseSummary: boolean;

    @ViewChild(ThirdPartySectionDirective, {static: true}) thirdPartySection!: ThirdPartySectionDirective;

    ngOnInit(): void {        
        this.loadThirdPartySectionComponent();
        this.isInitialized = true;
    }

    async loadThirdPartySectionComponent() {
        const viewContainerRef = this.thirdPartySection.viewContainerRef;
        viewContainerRef.clear();

        const factory = await this.getComponent();

        this.componentRef = viewContainerRef.createComponent<ThirdPartySectionComponent>(factory);
        this.embeddedData.isCaseSummary = this.isCaseSummary;
        
        this.componentRef.instance.embeddedData = this.embeddedData;
    }

    async getComponent() {
        switch (this.embeddedData.integrationId) {
            case IntegrationEnum.Magnum:
                this.embeddedData.isCaseSummary = this.isCaseSummary;
                //Show spinner only when in the runtime
                if (!this.isCaseSummary) {
                    this.appService.display(true);
                }
                return MagnumComponent;
            case IntegrationEnum.Mras:
                return MrasInterviewComponent;
            default:
                break;
        }
    }
}

export interface EmbeddedIntegrationData {
    baseUrl: string;
    integrationId: string;
    component: any;
    readonly: boolean;
    payloadData: string;
    isCaseSummary?: boolean;
}

export interface ThirdPartySectionComponent {
    embeddedData: EmbeddedIntegrationData;
}
